import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetUsers, EditUser, CreateNewUser, DeleteUser, GetUserAccessRight, GetConsultantCost } from './usersAction'
import { Typography, Card, Tabs, Tab, Container, Grid, TextField, Button, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import UserForm from './UserForm';
import AccessRight from './AccessRight'
import moment from 'moment'
import Costs from './Costs';
import isEmpty from 'lodash.isempty';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import { LogoutAction } from '../../actions';
import {
  Prompt
} from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Card className="p-40">{children}</Card>}
    </Typography>
  );
}

class Users extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      banutzer: '',
      currentTab: 0,
      listData: [],
      nachName: '',
      vorName: '',
      anrede: '',
      title: '',
      eintritt: '',
      austritt: '',
      loginName: '',
      consultentFunction: [],
      consultentId: '',
      password: '',
      confirmPassword: '',
      countryList: [],
      countryID: '',
      categoryList: [],
      categoryId: '',
      active: "1",
      street: '',
      zipcode: '',
      city: '',
      mail: '',
      agreedDate: '',
      newUser: '',
      editedUser: '',
      deleteUser: '',
      isDeleteContactDialogOpen: false,
      isConfirmationDialogOpen: false,
      changeCategory: false,
      endDateError: false,
      startDateError: false,
      error: [],
      accessErrorDialog: false,
      isBlocking: false,
      sideBarDrawer: true
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.users) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetUsers } = this.props
    GetUsers()
  }
  handleTabChange = (e, newTabIndex) => {
    const { editMode, isBlocking } = this.state
    if (editMode) {
      if (!isBlocking)
        this.setState({ currentTab: newTabIndex })
      else {
        let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

        if (retVal === true) {
          this.setState({ isBlocking: false, currentTab: newTabIndex })
        } else {
          this.setState({ isBlocking: false }, () => setTimeout(() => {
            this.setState({ isBlocking: true })
          }, 100))
        }
      }

    }
  }
  isBlockingCheck = () => {
    this.setState({ isBlocking: true })
  }
  isBlockingCheckfalse = () => {
    this.setState({ isBlocking: false })
  }

  handleFieldsChange = (e, key) => {
    if (key === "nachname") {
      this.setState({ nachName: e.target.value, isBlocking: true })
    } else if (key === "vorname") {
      this.setState({ vorName: e.target.value, isBlocking: true })
    }
    else if (key === "anrede") {
      this.setState({ anrede: e.target.value, isBlocking: true })
    }
    else if (key === "title") {
      this.setState({ title: e.target.value, isBlocking: true })
    }
    else if (key === "active") {
      this.setState({ active: !this.state.active })
    }
    else if (key === "consultant") {
      this.setState({ consultentId: e.target.value, isBlocking: true })
    }
    else if (key === "country") {
      this.setState({ countryID: e.target.value, isBlocking: true })
    }
    else if (key === "category") {
      this.setState({ categoryId: e.target.value, isBlocking: true })
      if (this.state.editMode) {
        this.setState({ isConfirmationDialogOpen: true })
      }
    }
    else if (key === "loginname") {
      this.setState({ loginName: e.target.value, isBlocking: true })
    }
    else if (key === "street") {
      this.setState({ street: e.target.value, isBlocking: true })
    }
    else if (key === "zipcode") {
      this.setState({ zipcode: e.target.value, isBlocking: true })
    }
    else if (key === "city") {
      this.setState({ city: e.target.value, isBlocking: true })
    }
    else if (key === "mail") {
      this.setState({ mail: e.target.value, isBlocking: true })
    }
    else if (key === "password") {
      this.setState({ password: e.target.value, isBlocking: true })
    }
    else if (key === "confirmpass") {
      this.setState({ confirmPassword: e.target.value, isBlocking: true })
    }
    else if (key === "eintritt") {
      if (e !== null) {
        let date = moment(e._d).format("DD.MM.YYYY");
        this.setState({ eintritt: date, isBlocking: true })
      } else {
        this.setState({ eintritt: "", isBlocking: true })
      }
    }
    else if (key === "austritt") {
      if (e !== null) {
        let date = moment(e._d).format("DD.MM.YYYY");
        this.setState({ austritt: date, isBlocking: true })
      } else {
        this.setState({ austritt: "", isBlocking: true })
      }

    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { users_list, access_error, error_validation, new_user, edited_user, delete_success, lands_list, consultant_list, categories_list } = this.props
    const { userId } = this.state
    if (nextProps.users_list !== users_list) {
      this.setState({ listData: nextProps.users_list })
    }
    else if (nextProps.lands_list !== lands_list) {
      this.setState({ countryList: nextProps.lands_list })
    }
    if (nextProps.categories_list !== categories_list) {
      this.setState({ categoryList: nextProps.categories_list })
    }
    else if (nextProps.consultant_list !== consultant_list) {
      this.setState({ consultentFunction: nextProps.consultant_list })
    }
    else if (nextProps.new_user !== new_user) {
      this.setState({ newUser: nextProps.new_user, isBlocking: false, userId: nextProps.new_user.id, editMode: true })
      this.props.GetUserAccessRight(nextProps.new_user.id)
    }
    else if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
    else if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
    else if (nextProps.edited_user !== edited_user) {
      this.setState({ editedUser: nextProps.edited_user, isBlocking: false }, () => this.getUserData(nextProps.edited_user))
    } else if (nextProps.delete_success !== delete_success) {
      this.setState({ deleteUser: userId, isBlocking: false })
      this.resetForm("delete", nextProps.users_list)
    }
  }

  getUserData = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      let time = item.daclarationagreed !== null ? item.daclarationagreed.substr(11, 5) : ''
      this.setState({
        userId: item.id,
        nachName: item.lastname,
        vorName: item.firstname,
        loginName: item.loginname,
        anrede: item.salutation,
        title: item.title,
        active: item.active,
        eintritt: item.startdate !== null ? moment(item.startdate).format("DD.MM.YYYY") : '',
        austritt: item.enddate !== null ? moment(item.enddate).format("DD.MM.YYYY") : '',
        categoryId: item.category_id,
        consultentId: item.consultant_function_id,
        countryID: item.country_id,
        street: item.street,
        zipcode: item.zipcode,
        city: item.city,
        mail: item.email,
        agreedDate: item.daclarationagreed !== null ? moment(item.daclarationagreed).format("DD.MM.YYYY") + " " + time : '',
        banutzer: item.lastname + " " + item.firstname,
        editMode: true,
        password: '',
        confirmPassword: '',
        currentTab: 0,
        isBlocking: false,
        error: []
      })
      this.props.GetConsultantCost(item.id)
      setTimeout(() => {
        this.focusTextInput()
      }, 200)
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getUserData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  createUser = () => {
    const { CreateNewUser, EditUser } = this.props
    const { editMode } = this.state
    const dataObj = this.state
    if (editMode) {
      EditUser(dataObj)
    }
    else {
      CreateNewUser(dataObj)
    }
  }
  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }
  deleteUser = () => {
    const { DeleteUser } = this.props
    const { userId } = this.state
    DeleteUser(userId)
    this.setState({ isDeleteContactDialogOpen: false })
  }

  resetForm = (check, data) => {
    if (check === "delete") {
      this.baseState.listData = data;
    } else {
      this.baseState.listData = this.props.users_list;
    }
    this.baseState.countryList = this.props.lands_list;
    this.baseState.categoryList = this.props.categories_list;
    this.baseState.consultentFunction = this.props.consultant_list;
    this.baseState.newUser = this.state.newUser;
    this.baseState.editedUser = this.state.editedUser;
    this.baseState.userId = this.state.userId;
    this.baseState.editMode = false;
    this.setState(this.baseState)
    setTimeout(() => {
      this.focusTextInput()
    }, 300)
  }



  render() {
    const dataObj = this.state
    const { isloading, user_consultant_costs, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <div container="true" spacing={3} className={`mainBlock mainslideblock ${dataObj.sideBarDrawer ? "" : "mainBlock-wide"}`}>
            {isEmpty(dataObj.error.message) ?
              <Fragment>
                <div className={`sidebar-left ${dataObj.sideBarDrawer ? "" : "close"}`}>
                  <button className="actionButton">
                    <ArrowLeftIcon onClick={() => this.setState({ sideBarDrawer: !dataObj.sideBarDrawer })}></ArrowLeftIcon>
                  </button>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neuer Benutzer"}
                      listData={dataObj.listData}
                      newList={dataObj.newUser}
                      editedList={dataObj.editedUser}
                      deleteList={dataObj.deleteUser}
                      getDataOfSelectedItemFunc={this.getUserData}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.users)}
                      activeField={true}

                    />
                  </div>
                </div>
                <div className="mainContent">
                  <div className="rightBlock liproCard">
                    <span style={{
                      display: 'inline-flex',
                      padding: '10px',
                    }}>Benutzer</span>
                    <TextField disabled size="small" value={dataObj.banutzer} className="innerInput" variant="outlined" />
                    <Prompt
                      when={dataObj.isBlocking}
                      message={location =>
                        `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                      }
                    />
                    <Tabs
                      value={dataObj.currentTab}
                      onChange={this.handleTabChange}
                      indicatorColor="primary"
                      textColor="primary">
                      <Tab label="Benutzerstammdaten" />
                      <Tab label="Zugriffsrechte" style={Number(access_rights.consultant_categories) === 0 ? { display: "none" } : {}} /> :
                      <Tab label="Kosten" />
                    </Tabs>
                    <TabPanel
                      value={dataObj.currentTab}
                      index={0}>
                      <UserForm
                        textInput={this.textInput}
                        dataObj={dataObj}
                        handleFieldsChange={this.handleFieldsChange}
                        createUserFunction={this.createUser}
                        deleteUser={this.deleteUser}
                        openDeleteDialog={this.openDeleteDialog}
                        closeDeleteContactDialog={this.closeDeleteContactDialog} />
                    </TabPanel>
                    <TabPanel
                      value={dataObj.currentTab}
                      index={1}>
                      <AccessRight
                        isBlockingCheck={this.isBlockingCheck}
                        isBlockingCheckfalse={this.isBlockingCheckfalse}
                        userId={dataObj.userId}
                      />
                    </TabPanel>
                    <TabPanel
                      value={dataObj.currentTab}
                      index={2}>
                      <Costs
                        userId={dataObj.userId}
                        user_consultant_costs={user_consultant_costs}
                      />
                    </TabPanel>
                  </div>
                </div>
              </Fragment>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{dataObj.error.message}</h3>
                </div>
              </Grid>
            }
          </div>
        </Container>
        <Dialog
          open={dataObj.isConfirmationDialogOpen}
        >
          <DialogTitle>Änderung der Kategorie</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Sollen auch die Zugriffsrechte entsprechend geändert werden?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ isConfirmationDialogOpen: false, changeCategory: true })} size="small" variant="outlined" color="primary" autoFocus>
              Ja
              </Button>
            <Button onClick={() => this.setState({ isConfirmationDialogOpen: false, changeCategory: false })} size="small" variant="outlined" color="secondary">
              Nein
              </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={dataObj.accessErrorDialog}
        >
          <DialogTitle>Benutzer</DialogTitle>
          <DialogContent>
            <DialogContentText >
              {access_error && access_error.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
              Abbrechen
              </Button>
          </DialogActions>
        </Dialog>
      </div >
    )
  }
}

const mapStateToProps = ({ usersData, categories, consultant, land }) => {
  return {
    isloading: usersData.loading,
    access_error: usersData.access_error,
    users_list: usersData.users_list,
    new_user: usersData.new_user,
    edited_user: usersData.edited_user,
    delete_success: usersData.success,
    // user_access_rights: usersData.user_access_rights,
    user_consultant_costs: usersData.user_consultant_costs,
    error_validation: usersData.error_message,
    categories_list: categories.categories_list,
    consultant_list: consultant.consultant_list,
    lands_list: land.lands_list,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetUsers: () => dispatch(GetUsers()),
    EditUser: (name) => dispatch(EditUser(name)),
    CreateNewUser: (id, data) => dispatch(CreateNewUser(id, data)),
    DeleteUser: (id) => dispatch(DeleteUser(id)),
    GetUserAccessRight: (id) => dispatch(GetUserAccessRight(id)),
    GetConsultantCost: (id) => dispatch(GetConsultantCost(id)),
    LogoutAction: () => dispatch(LogoutAction()),

  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Users)